// extracted by mini-css-extract-plugin
export default {"game":"Game_game__Rdb0V","status":"Game_status__97++b","resetBtn":"Game_resetBtn__z-sap"};